import React, { useReducer, createContext, useState, useEffect } from 'react';
import trGeoJSON from './tr-geojson';
import { ReportEndpoints } from '@REPORTS';
import { useGET } from '@API2';
import { Spin } from 'antd';

import { divIcon } from 'leaflet';

export const DistanceContext = createContext({});

const initialState = {
  distanceParamVisible: false,
  geo: trGeoJSON.features.map((item) => ({
    ...item,
    properties: {
      ...item.properties,
      icon: new divIcon({
        html: item.properties.name,
      }),
    },
  })),
};

const colorSchema = Object.freeze({
  default: '#09316B',
  active: '#f5f5f5',
  1: '#ffe7ba',
  2: '#8b7355',
  3: '#0066a9',
  4: '#1a8503',
  5: '#9702a5',
  6: '#e10202',
  7: '#828282',
  8: '#fb9201',
});

const reducer = (state, action) => {
  const { type, payload } = action;
  const pIndex = state.geo.findIndex((x) => x.id === payload?.id);

  switch (type) {
    case 'SET_POS':
      return {
        ...state,
        geo: state.geo.map((item, index) =>
          index === pIndex
            ? {
                ...item,
                properties: {
                  ...item.properties,
                  label: payload.pos,
                },
              }
            : item
        ),
      };
    case 'SET_SELECTED':
      return {
        ...state,
        geo: state.geo.map((item) => {
          let day = null;
          const that = payload.data.find((x) => x.arrivalCity === item.id);
          if (that) {
            day = that.day;
          }
          return {
            ...item,
            properties: {
              ...item.properties,
              day,
              color:
                item.id === payload.id
                  ? colorSchema['active']
                  : colorSchema[day],
            },
          };
        }),
      };
    case 'SET_MODAL':
      return {
        ...state,
        distanceParamVisible: payload,
      };
    case 'RESET_SELECTED':
      return initialState;
    default:
      break;
  }
};

const DistanceProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [current, setCurrent] = useState({ id: null, name: null });
  const [modalVisible, setModalVisible] = useState(false);

  const {
    data = [],
    loading,
    mutate,
  } = useGET(
    ReportEndpoints.distanceMatrix,
    current?.id && `?id=${current?.id}`
  );

  useEffect(() => {
    if (!loading && data.length > 0) {
      dispatch({ type: 'SET_SELECTED', payload: { id: current.id, data } });
    }
  }, [loading, data, current.id]);

  const onSelect = async (id, name) => {
    if (id === current.id) {
      dispatch({ type: 'RESET_SELECTED' });
      setCurrent({ id: null, name: null });
    } else {
      setCurrent({ id, name });
    }
  };

  return (
    <DistanceContext.Provider
      value={{
        ...state,
        current,
        modalVisible,
        dispatch,
        setLabelPosition: (id, pos) =>
          dispatch({ type: 'SET_POS', payload: { id, pos } }),
        setModalVisible: (val) => setModalVisible(val),
        onClick: (id, name) => onSelect(id, name),
        mutate: () => mutate(),
      }}
    >
      <Spin spinning={current?.id && loading}>{children}</Spin>
    </DistanceContext.Provider>
  );
};

export default DistanceProvider;
